<template>
  <div class="current-time">
    <div class="line-through">
      <div class="datetime"><span class="date" v-if="showDate">{{date}}</span><span class="time">{{time}}</span></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showSeconds: {
      type: Boolean,
      default: true
    }, 
    showDate: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      interval: null,
      days: ['SÖN', 'MÅN', 'TIS', 'ONS', 'TOR', 'FRE', 'LÖR'],
      months: ['JAN', 'FEB', 'MAR', 'APR', 'MAJ', 'JUN', 'JUL', 'AUG', 'SEP', 'OKT', 'NOV', 'DEC'],
      date: null,
      time: null
    }
  },
  created () {
    this.updateTime()
    this.interval = setInterval(() => {
      this.updateTime()
    }, 1000)
  },
  beforeDestroy () {
    clearInterval(this.interval)
    this.interval = null
  },
  methods: {
    updateTime () {
      var cd = new Date()
      this.time = `${this.zeroPadding(cd.getHours())}:${this.zeroPadding(cd.getMinutes())}`;
      if (this.showSeconds) this.time += `:${this.zeroPadding(cd.getSeconds())}`;
      this.date = `${this.days[cd.getDay()]} ${cd.getDate()} ${this.months[cd.getMonth()]}`;
    },
    zeroPadding: function (val) {
      return val.toString().length === 1 ? '0' + val : val
    }
  }
}
</script>

<style scoped lang="scss">
  .current-time {
    font-size: 2rem;
    text-align: center;
    margin-bottom: 4rem;

    .line-through {
      position: relative;
      &::before {
        border-top: 2px solid rgba(255, 255, 255, 0.5);
        content: "";
        margin: 0 auto;
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        z-index: 0;
      }
      .datetime {
        position: relative;
        display: inline-block;
        padding: 0 0;
        background: #000;
        z-index: 1;
        width: 370px;

        .time, .date {
          display: block;
        }
        .time {
          font-family: 'Paytone One';
          font-size: 4rem;
          font-weight: 400;
          letter-spacing: 2px;
          line-height: 3rem;
        }
      }
    }
  }
</style>
